import React from 'react';
import withIcon from '../utilities/withIcon';

const IconChartBarVert = () => {
  return (
    <g>
      <path d="m15.0185 14.1387h-1.2744v-12.9776a.7.7 0 0 0 -.7-.7h-3.3625a.7.7 0 0 0 -.7.7v1.6055h-2.6632a.7.7 0 0 0 -.7.7v4.3654h-2.6624a.7.7 0 0 0 -.7.7v5.6065h-1.2746a.7.7 0 0 0 0 1.4h14.0372a.7.7 0 1 0 0-1.4zm-4.6367-12.2774h1.9619v12.2764h-1.9619zm-3.3633 2.3057h1.9629v9.9707h-1.9629zm-3.3623 5.0654h1.962v4.9053h-1.962z" />
    </g>
  );
};

export default withIcon(IconChartBarVert);
